module.exports = __webpack_public_path__ + "media/images/lane/map_mobile-c24feab7865d7a92f1d32076418858a4.svg";